import { Check } from "lucide-react";

interface FacetFormToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function FacetFormToggle({ label, checked, onChange }: FacetFormToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`group inline-flex w-fit max-w-full items-center gap-2.5 rounded-lg px-3.5 py-2.5 text-left transition ${
        checked
          ? "bg-indigo-50 ring-1 ring-indigo-200"
          : "bg-slate-50 ring-1 ring-slate-200 hover:ring-slate-300"
      }`}
    >
      <span
        className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-md transition ${
          checked
            ? "bg-indigo-600 text-white"
            : "bg-white ring-1 ring-slate-300 group-hover:ring-slate-400"
        }`}
      >
        {checked && <Check size={13} strokeWidth={2.5} />}
      </span>
      <span className={`text-[12px] font-medium leading-tight ${checked ? "text-indigo-700" : "text-slate-600"}`}>
        {label}
      </span>
    </button>
  );
}
